import { render, staticRenderFns } from "./actionlist.vue?vue&type=template&id=2879a3be&scoped=true&"
import script from "./actionlist.vue?vue&type=script&lang=js&"
export * from "./actionlist.vue?vue&type=script&lang=js&"
import style0 from "./actionlist.vue?vue&type=style&index=0&id=2879a3be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2879a3be",
  null
  
)

export default component.exports